import {
  TPaymentByModel,
  TPaymentManualInput,
} from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const insertPaymentInstallment = ({
  reservationId,
  payload,
}: {
  reservationId: string;
  payload: TPaymentManualInput | TPaymentByModel;
}) => {
  return API.post(`api/accommodation/calculations/${reservationId}/payment`, payload).then(
    response => response?.data,
  );
};
